import React from 'react'
import { find, get } from 'lodash'
export const renderItemFieldValue = (value: any, valueField: string, labelField: string, dataSource: any[]) => {
  const targetItem = find(dataSource, item => get(item, valueField) === value)
  const renderText = targetItem ? get(targetItem, labelField) : ''

  return renderText !== '' ? <span>{renderText}</span> : null
}
